// src/hooks/useFeed.js
import axiosInstance from 'utils/axiosInstance';
import { useInfiniteQuery } from '@tanstack/react-query';

export default function useFeed(selectedTopics = []) {
  return useInfiniteQuery({
    queryKey: ['feed', selectedTopics],
    queryFn: ({ pageParam }) => {
      const params = { limit: 20 };

      if (pageParam) {
        params.score = pageParam.score;
        params.createdAt = pageParam.createdAt;
      }

      if (selectedTopics.length > 0) {
        params.topics = selectedTopics.join(',');
      }

      return axiosInstance.get('/knovia/myInfo/feed', { params })
        .then(res => res.data);
    },
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    keepPreviousData: true, // 👈 prevents blinking
  });
}